// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","732":"e4596b42","977":"0aa2c955"}[chunkId] + ".chunk.js";
};